exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UnitOfMeasure-label{color:var(--text-primary);font-size:14px;font-weight:500;margin-top:32px;margin-bottom:16px}.UnitOfMeasure-info{color:var(--text-primary);font-size:13px;font-weight:normal;margin-bottom:16px}", ""]);

// exports
